import { render, staticRenderFns } from "./page5.vue?vue&type=template&id=6024e4c4&scoped=true"
import script from "./page5.vue?vue&type=script&lang=js"
export * from "./page5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6024e4c4",
  null
  
)

export default component.exports